import React from 'react';
import {LoadingDialog} from '../../../../_metronic/_partials/controls';

export function LawLoadingDialog() {

  return <LoadingDialog isLoading={false}/>;
}
